import { createTypes } from '../../utils/helpers';

export const PLATFORM_FETCH_MENU_ITEM: any = createTypes(
  'PLATFORM_FETCH_MENU_ITEM',
);
export const PLATFORM_FETCH_PRODUCT_GROUPS: any = createTypes(
  'PLATFORM_FETCH_PRODUCT_GROUPS',
);
export const PLATFORM_FETCH_PRODUCT_GROUPS_FILTERED: any = createTypes(
  'PLATFORM_FETCH_PRODUCT_GROUPS_FILTERED',
);
export const PLATFORM_FETCH_PLATFORMS: any = createTypes(
  'PLATFORM_FETCH_PLATFORMS',
);
export const PLATFORM_FETCH_MENU_ITEMS: any = createTypes(
  'PLATFORM_FETCH_MENU_ITEMS',
);
export const PLATFORM_FETCH_MENU_ITEMS_TO_VALIDATE: any = createTypes(
  'PLATFORM_FETCH_MENU_ITEMS_TO_VALIDATE',
);
export const PLATFORM_FETCH_MENU_ITEMS_CATALOG: any = createTypes(
  'PLATFORM_FETCH_MENU_ITEMS_CATALOG',
);
export const PLATFORM_FETCH_MENU_ITEMS_FILTERED: any = createTypes(
  'PLATFORM_FETCH_MENU_ITEMS_FILTERED',
);
export const PLATFORM_ASSIGN_UNASSIGN_MENU_ITEMS_TO_RESTAURANTS: any =
  createTypes('PLATFORM_ASSIGN_UNASSIGN_MENU_ITEMS_TO_RESTAURANTS');

export const PLATFORM_CLEAR_PRODUCT_GROUPS = 'PLATFORM_CLEAR_PRODUCT_GROUPS';
export const PLATFORM_CLEAR_PRODUCT_GROUPS_CATALOG =
  'PLATFORM_CLEAR_PRODUCT_GROUPS_CATALOG';
export const PLATFORM_CLEAR_MENU_ITEMS = 'PLATFORM_CLEAR_MENU_ITEMS';
export const PLATFORM_CLEAR_MENU_ITEMS_CATALOG =
  'PLATFORM_CLEAR_MENU_ITEMS_CATALOG';
export const PLATFORM_CLEAR_PLATFORMS = 'PLATFORM_CLEAR_PLATFORMS';
